import React from 'react'
import classNames from 'classnames'
import { func } from 'prop-types'
import MyItemsBrowseViewContainer from 'containers/designSidepanel/MyItemsBrowseViewContainer'
import ProductBrowseViewContainer from 'containers/designSidepanel/ProductBrowseViewContainer'
import FavoritesBrowseViewContainer from 'containers/designSidepanel/FavoritesBrowseViewContainer'
import DebugViewContainer from 'containers/admin/DebugViewContainer'
import RatingPanelViewContainer from 'containers/designSidepanel/RatingPanelViewContainer'
import SwapViewContainer from 'containers/designSidepanel/SwapViewContainer'
import { sidepanelTabsType } from 'models/propTypes'
import SkipLinks from 'components/SkipLinks'
import { BROWSE, DESIGN, HEADER } from 'components/SkipLinks/constants'

require('./SidepanelBody.scss')

const SidepanelBody = ({ onToggle, selectedTabs }) => {
    const { isSwapSelected, isBrowseSelected, isMyListSelected, isFavoritesSelected, isDebugSelected, isRateSelected } =
        selectedTabs

    return (
        <>
            {isBrowseSelected ? (
                <div
                    className={classNames('sidepanelBody', { active: isBrowseSelected })}
                    data-testid="sidepanel-body"
                    id="sidepanel-body-products"
                    role="tabpanel"
                    aria-labelledby="sidepanel-menu-products"
                >
                    <SkipLinks skipLinks={[DESIGN, HEADER]} skipContext={BROWSE} />
                    <ProductBrowseViewContainer />
                </div>
            ) : null}

            {isSwapSelected ? (
                <div
                    className={classNames('sidepanelBody', { active: isSwapSelected })}
                    role="tabpanel"
                    id="sidepanel-body-swap"
                    aria-labelledby="sidepanel-menu-swap-items"
                >
                    <SkipLinks skipLinks={[DESIGN, HEADER]} skipContext={BROWSE} />
                    <SwapViewContainer onToggle={onToggle} />
                </div>
            ) : null}

            {isMyListSelected ? (
                <div
                    className={classNames('sidepanelBody active')}
                    role="tabpanel"
                    id="sidepanel-body-my-items"
                    aria-labelledby="sidepanel-menu-my-items"
                >
                    <SkipLinks skipLinks={[DESIGN, HEADER]} skipContext={BROWSE} />
                    <MyItemsBrowseViewContainer />
                </div>
            ) : null}
            {isFavoritesSelected ? (
                <div
                    className={classNames('sidepanelBody active')}
                    role="tabpanel"
                    id="sidepanel-body-favorites"
                    aria-labelledby="sidepanel-menu-favorites"
                >
                    <SkipLinks skipLinks={[DESIGN, HEADER]} skipContext={BROWSE} />
                    <FavoritesBrowseViewContainer />
                </div>
            ) : null}

            {isDebugSelected ? (
                <div
                    className={classNames('sidepanelBody active')}
                    role="tabpanel"
                    id="sidepanel-body-debug"
                    aria-labelledby="sidepanel-menu-debug"
                >
                    <SkipLinks skipLinks={[DESIGN, HEADER]} skipContext={BROWSE} />
                    <DebugViewContainer />
                </div>
            ) : null}
            {isRateSelected ? (
                <div
                    className={classNames('sidepanelBody active')}
                    role="tabpanel"
                    id="sidepanel-body-rate"
                    aria-labelledby="sidepanel-menu-rate"
                >
                    <SkipLinks skipLinks={[DESIGN, HEADER]} skipContext={BROWSE} />
                    <RatingPanelViewContainer />
                </div>
            ) : null}
        </>
    )
}

SidepanelBody.defaultProps = {
    onToggle: null,
}

SidepanelBody.propTypes = {
    onToggle: func,
    selectedTabs: sidepanelTabsType.isRequired,
}

export default SidepanelBody
